// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle-container[data-v-33a01d89] {\n  display: inline-block;\n  width: 100%;\n}\n.trigger[data-v-33a01d89] {\n  color: #999999;\n  font-size: 14px;\n  height: 25px;\n  line-height: 25px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.trigger p[data-v-33a01d89] {\n  width: 100px;\n  cursor: pointer;\n}\n.trigger p[data-v-33a01d89]:hover {\n  color: #333333;\n}\n", ""]);
// Exports
module.exports = exports;
